<template>
  <div class="space-y-2 prose dark:prose-invert">
    <p>Your email and authentication token are stored securely using modern encryption and access control measures.</p>
    <p>While we implement industry-standard protections, no method of storage or transmission over the Internet is completely secure. We cannot guarantee absolute security.</p>
  </div>
</template>